export default {
  user(state) {
    return state.user;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  currentTheme(state) {
    return state.theme || "dark";
  },
  isAdmin(state) {
    return !!state.isMaster;
  },
};
